
import React from 'react';
import { motion } from 'framer-motion';

interface ProcessStepProps {
  step: {
    icon: React.ReactNode;
    title: string;
    description: string;
    details: string;
  };
  index: number;
  isReversed: boolean;
}

const ProcessStep = ({ step, index, isReversed }: ProcessStepProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: isReversed ? 30 : -30 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ delay: index * 0.15, duration: 0.6 }}
      viewport={{ once: true }}
      className={`flex items-center gap-4 md:gap-6 mb-6 md:mb-8 ${
        isReversed ? 'flex-row-reverse' : ''
      }`}
    >
      <div className="flex-1">
        <motion.div
          whileHover={{ scale: 1.02 }}
          className="bg-white p-4 md:p-5 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
        >
          <div className="flex items-center mb-2 md:mb-3">
            {step.icon}
            <h3 className="text-base md:text-lg font-bold text-gray-900 ml-3">
              {step.title}
            </h3>
          </div>
          <p className="text-sm md:text-base text-gray-700 mb-2 font-medium">
            {step.description}
          </p>
          <p className="text-xs md:text-sm text-gray-600">
            {step.details}
          </p>
        </motion.div>
      </div>
      
      {index < 4 && (
        <div className="hidden lg:block">
          <motion.div
            initial={{ scale: 0 }}
            whileInView={{ scale: 1 }}
            transition={{ delay: index * 0.15 + 0.4, duration: 0.4 }}
            viewport={{ once: true }}
            className="w-8 h-8 md:w-10 md:h-10 bg-gradient-to-r from-emerald-500 to-blue-500 rounded-full flex items-center justify-center shadow-md"
          >
            <div className="w-2 h-2 md:w-3 md:h-3 border-2 border-white rounded-full bg-white"></div>
          </motion.div>
        </div>
      )}
    </motion.div>
  );
};

export default ProcessStep;
